import type { ReactNode } from "react";

export function TriageWorkbenchShell({
  children,
  open,
  onClose,
}: {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
}) {
  return (
    <section
      className={
        open
          ? "triage-workbench-shell real-workbench-drawer is-open"
          : "triage-workbench-shell real-workbench-drawer"
      }
      data-overlay-layer="primary-workbench"
      role="dialog"
      aria-modal="false"
      aria-hidden={!open}
      aria-label="询单处理工作台"
      aria-live="polite"
    >
      <button
        type="button"
        className="triage-workbench-shell-close real-workbench-close"
        aria-label="关闭当前询单工作台"
        onClick={onClose}
      >
        ×
      </button>
      {children}
    </section>
  );
}

export function WorkbenchSecondaryPanelShell({
  title,
  children,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <div
      className="workbench-secondary-panel-layer"
      data-overlay-layer="secondary-peek"
      role="presentation"
      onClick={onClose}
    >
      <aside
        className="workbench-secondary-panel-shell"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="workbench-secondary-panel-header">
          <h2>{title}</h2>
          <button type="button" aria-label="关闭侧边查看" onClick={onClose}>
            ×
          </button>
        </header>
        <div className="workbench-secondary-panel-body">{children}</div>
      </aside>
    </div>
  );
}

/** Backwards-compatible name for existing read-only context panels. */
export const WorkbenchPeekShell = WorkbenchSecondaryPanelShell;
